import { render } from "./cookieconsent.vue?vue&type=template&id=0fdf8312&scoped=true"
import script from "./cookieconsent.vue?vue&type=script&lang=js"
export * from "./cookieconsent.vue?vue&type=script&lang=js"

import "./cookieconsent.vue?vue&type=style&index=0&id=0fdf8312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdf8312"]])

export default __exports__